import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { utilityCostFields } from './common/utilityCostFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { allCleanPowerFields } from './common/cleanPowerFields';
import { msg } from '@lingui/core/macro';

export const electricityConsumptionDatacenterMetadata = {
  displayName: msg({
    message: 'Co-located data center electricity consumption',
    context:
      'Activity data schema name for co-located data center electricity consumption',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...allCleanPowerFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    clean_power_percent_for_facility_overhead: {
      displayName: msg({
        message: 'Clean power percentage for facility overhead',
        context:
          'The percentage of clean power used to power the energy overhead of the datacenter (computed based on the `pue`)',
      }),
      externalDescription: msg({
        message:
          'The percentage of clean power used to power the energy overhead of the datacenter (computed based on the `pue`)',
        context: 'Clean power percentage for facility overhead',
      }),
    },
    pue: {
      displayName: msg({
        message: 'Power usage effectiveness',
        context:
          'The ratio of the total energy used to the amount of energy dedicated to powering datacenter equipment',
      }),
      externalDescription: msg({
        message:
          'The ratio of the total energy used to the amount of energy dedicated to powering datacenter equipment',
        context: 'Power usage effectiveness',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Datacenter electricity usage',
        context: 'The consumption of electricity in a datacenter.',
      }),
      externalDescription: msg({
        message: 'The consumption of electricity in a datacenter.',
        context: 'Datacenter electricity usage',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
